import { useParams } from "react-router";

import pros50 from "@/../../hypetrain/static/img/50pros.png";
import degreed from "@/../../hypetrain/static/img/degreed.png";
import jpm from "@/../../hypetrain/static/img/jpm.png";
import learnin from "@/../../hypetrain/static/img/learnin.png";
import sap from "@/../../hypetrain/static/img/sap.png";
import { Box, Flex } from "@/components/layout/flexbox";

export function InPartnership() {
  const { p } = useParams();
  const partner = p?.toLowerCase();
  const partnership =
    partner === "sap" ? (
      <img src={sap} style={{ height: 30 }} />
    ) : partner === "jpm" ? (
      <img src={jpm} style={{ height: 30 }} />
    ) : partner === "50pros" ? (
      <img src={pros50} style={{ height: 30 }} />
    ) : partner === "learnin" ? (
      <img src={learnin} style={{ height: 30 }} />
    ) : partner === "degreed" ? (
      <img src={degreed} style={{ height: 30 }} />
    ) : null;

  if (!partnership) return null;
  return (
    <Flex alignItems="center" mb={3} fontSize={20} flexWrap="wrap">
      <Box mr={2}>In partnership with</Box>
      <Box>{partnership}</Box>
    </Flex>
  );
}
